// Portable semantic content blocks for canonical documents.
import { richText } from './richText';
export const p = (content) => ({
    type: 'paragraph',
    content: richText(content),
});
export const list = ({ ordered, items, }) => ({
    type: 'list',
    ordered,
    items: items.map(richText),
});
export const quote = ({ content, attribution, }) => ({
    type: 'quote',
    content: richText(content),
    attribution: attribution ? richText(attribution) : undefined,
});
export const image = ({ imageAsset, imageAlt, caption, maxWidth, }) => ({
    type: 'image',
    imageAsset,
    imageAlt,
    caption: caption ? richText(caption) : undefined,
    maxWidth,
});
export const table = ({ variant, columns, rows, }) => ({
    type: 'table',
    variant,
    columns: columns.map(richText),
    rows: rows.map((row) => row.map(richText)),
});
export const facts = ({ items, }) => ({
    type: 'facts',
    items: items.map((item) => ({
        label: richText(item.label),
        value: richText(item.value),
    })),
});
export const callout = ({ tone, content, }) => ({
    type: 'callout',
    tone,
    content: richText(content),
});
//# sourceMappingURL=block.js.map